import React, { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";
import dollar from "../../assets/payment/dollar.png";
import bank from "../../assets/payment/bank.png";
import { OrderCheckOutApi } from "../../ApiCalls/OrderCheckout";
import { TrendingProductsFetchApi } from "../../ApiCalls/TrendingProducts";
import MyOrderProductCard from "../../components/Orders/MyOrderProductCard";
import axios from "axios";
import { USER_URL } from "../../constant/api";
import { useAuth } from "../../context/AuthContext";

const Payment = ({ selectedAddress, SubmitOrder, setPopup }) => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState();
  const [fetchedOrder, setFetchedOrder] = useState([]);
  const [trendingProducts, setTrendingProducts] = useState([]);
  const { user } = useAuth();
  const paymentOptions = [
    {
      id: "Pay Now",
      name: "Pay Now",
      details: "Cards, UPI, Wallets",
      icon: bank,
    },
    {
      id: "cod",
      name: "Cash on Delivery",
      details: "Pay at the time of delivery",
      icon: dollar,
    },
  ];

  const payNow = async () => {
    try {
      const res = await USER_URL.post("/orders/place-order/razorpay/initiate/");
      const { razorpay_order_id, amount } = res.data.payment;
      const { razorpay_key } = res.data;
      const customerOrderNumber = res.data.customer_order_number;
      // console.log(" Razorpay Order ID:", customerOrderNumber);

      // console.log(" INIT RESPONSE", res.data);

      const options = {
        key: razorpay_key,
        currency: "INR",
        amount: amount,
        order_id: razorpay_order_id,
        name: "BricksnMix",
        description: "Order Payment",
        image: "/images/logo/icon_sg.png",
        handler: async function (response) {
          console.log("Payment Response:", response);
          const confirmData = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            customer_order_number: customerOrderNumber,
          };
          console.log("💳 Payment Confirmation Data:", confirmData);

          const verify = await USER_URL.patch(
            "/orders/place-order/razorpay/confirm/",
            confirmData,
          );
          console.log(" Payment Verification:", verify.data);
          if (verify.data.Status === "1") {
            setPopup({
              visible: true,
              success: true,
              button: true,
              showCloseIcon: false,
              message: "Payment Successful",
              subMessage: "Order Placed Successfully",
            });
          } else {
            setPopup({
              visible: true,
              success: false,
              // button: true,
              showCloseIcon: false,
              message: "Payment Failed",
              subMessage: "Please try again",
              Trybutton: true,
            });
          }
        },
        prefill: {
          name: user?.user_name || "User name",
          email: user?.email || "user@gmail.com",
          contact: "9999999999",
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          ondismiss: function () {
            console.log(" Razorpay popup closed");
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error(" Error in payNow:", err);
      setPopup({
        visible: true,
        success: false,
        // button: true,
        showCloseIcon: false,
        message: "Payment Failed",
        subMessage: "Please try again",
        Trybutton: true,
      });
    }
  };

  const handlePlaceOrder = () => {
    if (selectedPayment === "cod") {
      SubmitOrder(); // Call the SubmitOrder
    } else if (selectedPayment === "Pay Now") {
      // Placeholder for Razorpay logic
      console.log("Redirecting to Razorpay...");
      payNow();
    }
  };

  // Button should be enabled only when both are selected
  const isButtonEnabled = selectedAddress && selectedPayment;

  return (
    <div className="flex flex-col md:flex-row">
      <div className="w-full p-6">
        {/* Accordion for Payment Method */}
        <div
          className="flex cursor-pointer items-center justify-between rounded-md bg-slate-100 p-4 font-medium"
          onClick={() => setIsPaymentOpen(!isPaymentOpen)}
        >
          <h3 className="text-lg">2. Payment Method</h3>
          {isPaymentOpen ? <FaMinus /> : <FaPlus />}
        </div>

        {isPaymentOpen && (
          <div className="transform p-4 transition-all duration-1000">
            {/* Payment Selection Options */}
            {paymentOptions.map((payment) => (
              <div
                key={payment.id}
                className="mb-2 flex items-start gap-3 md:w-1/2"
                onClick={() => setSelectedPayment(payment.id)}
              >
                <div
                  className={`flex w-full cursor-pointer items-center gap-4 rounded border p-2 ${
                    selectedPayment === payment.id
                      ? "border-red-300 bg-red-200"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <input
                    type="radio"
                    id={payment.id}
                    name="payment"
                    className="size-4 accent-green-600"
                    checked={selectedPayment === payment.id}
                    onChange={() => setSelectedPayment(payment.id)}
                  />
                  <label
                    htmlFor={payment.id}
                    className="cursor-pointer text-left"
                  >
                    <h3 className="text-sm font-medium">{payment.name}</h3>
                    <p className="text-xs">{payment.details}</p>
                  </label>
                  <div className="flex flex-1 items-end justify-end">
                    {payment.icon && (
                      <img
                        src={payment.icon}
                        alt={`${payment.name} icon`}
                        className="mr-2 h-8 object-contain"
                      />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Submit order */}
        <div className="my-4 w-full">
          <button
            className={`w-full p-4 text-white ${
              isButtonEnabled
                ? "bg-brand-button-green-bg"
                : "cursor-not-allowed bg-gray-400"
            }`}
            disabled={!isButtonEnabled}
            onClick={handlePlaceOrder}
          >
            Place Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default Payment;
